export default "__VITE_ASSET__BQossMVc__"